import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getRole } from '../../../../../../../reducers';
import { can } from '../../../../../../../services';
import {
  requestPhaseItems, savePhaseItem, deletePhaseItem,
} from 'actionCreators/phase_items';
import LineItemTable from 'components/LineItemTable';
import MerchandiseTableRow from './merchandiseTableRow';
import phaseMerchandiseItem from 'types/phaseMerchandiseItem';

const LINE_ITEM_TYPE = 'phaseMerchandiseItems';

class PhaseMerchandiseItemTable extends Component {
  componentWillMount = () => (!this.hasParentLineItems() ?
    this.refreshLineItemList() : null);

  refreshLineItemList = () => this.props.requestPhaseItems(this.props.phaseId, LINE_ITEM_TYPE);

  handleDelete = lineItemId =>
    this.props.deletePhaseItem(this.props.phaseId, { id: lineItemId }, LINE_ITEM_TYPE);

  handleSave = lineItem => this.props.savePhaseItem(this.props.phaseId, lineItem, LINE_ITEM_TYPE);

  hasParentLineItems = () => this.props.parentLineItems.length > 0;

  render = () => (<LineItemTable
    title="Merchandise"
    refreshList={this.refreshLineItemList}
    readOnly={!can(this.props.role, 'update', 'labor')}
    cv={this.props.cv}
    accountingTable
  >
    {this.props.lineItems.map(item => <MerchandiseTableRow
      key={item.id}
      onSave={this.handleSave}
      onDelete={this.handleDelete}
      lineItem={item}
      readOnly={!can(this.props.role, 'update', 'labor')}
      phaseSource={this.props.phaseSource}
    />)}
  </LineItemTable>);
}

PhaseMerchandiseItemTable.defaultProps = {
  lineItems: [], parentLineItems: [], cv: false,
};

PhaseMerchandiseItemTable.propTypes = {
  phaseId: PropTypes.oneOfType([
    PropTypes.string, PropTypes.number,
  ]),
  phaseSource: PropTypes.string,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape(phaseMerchandiseItem),
  ),
  parentLineItems: PropTypes.arrayOf(
    PropTypes.shape(phaseMerchandiseItem),
  ),
  requestPhaseItems: PropTypes.func,
  savePhaseItem: PropTypes.func,
  deletePhaseItem: PropTypes.func,
  role: PropTypes.string.isRequired,
  cv: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => ({
  role: getRole(state),
  lineItems: (ownProps.parentLineItems || []).length > 0 ?
    ownProps.parentLineItems : state.phase.phaseMerchandiseItems.items,
});

export default connect(mapStateToProps, {
  requestPhaseItems,
  savePhaseItem,
  deletePhaseItem,
})(PhaseMerchandiseItemTable);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/components/phaseMerchandiseItemTable.jsx